<div class="page">
  <div class="topbar-container">
    <app-besharp-topbar
      [title]="title"
      [logo]="logo"
      [stickyBar]="true"
      [height]="60"
      [scrollThreshold]="30"
      [homeRoute]="homeRoute"
      [topbarItems]="topBarItems"
    >
      <ng-template #topbarRightBefore>
        <div style="min-width: 8vw">
          <button
            class="backend-health"
            [class.connected]="isBackendConnected"
            [class.disconnected]="!isBackendConnected"
            [class.checking]="isCheckingBackendHealth"
            (click)="refreshBackendHealth()"
            [title]="isBackendConnected ? 'Backend connected' : 'Backend disconnected'"
            type="button"
          >
            <span class="status-dot" aria-hidden="true"></span>
            <span class="status-label">{{ isBackendConnected ? 'Connected' : 'Disconnected' }}</span>
            @if (isCheckingBackendHealth) {
              <i class="pi pi-spin pi-spinner"></i>
            }
          </button>
        </div>
      </ng-template>
    </app-besharp-topbar>
  </div>

  <div class="sidebar-container">
    <app-besharp-sidebar
      [sidebarConfiguration]="sidebarConfiguration"
      (sidebarSizeChanged)="sidebarSizeChanged($event)"
    >
      <ng-template #headerTemplate>
        <div class="sidebar-header-template">
          <a routerLink="/app" class="new-chat-btn">
            <i class="pi pi-plus"></i>
            New Chat
          </a>
          <div class="sessions-meta">
            <span class="sessions-count">
              <i class="pi pi-comment"></i>
              {{ sessions.length }} conversation{{ sessions.length !== 1 ? 's' : '' }}
            </span>
            <button
              class="refresh-btn"
              [class.spinning]="loadingSessions"
              (click)="refreshSessions()"
              title="Refresh sessions"
            >
              <i class="pi pi-sync"></i>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template #sidebarFooterTemplate>
        <p-divider layout="horizontal" />
        <footer>
          <div class="sidebar-footer">
            <span>Datahub AI</span>
            <small>Sessions auto-expire after 30 days</small>
          </div>
        </footer>
      </ng-template>
      <ng-template #itemTemplate let-item>
        @if (item.link) {
          <a class="sidebar-item-link" [class.active]="isSessionSelected(item)" (click)="confirmSessionSwitch(item)">
            <div class="sidebar-item" [class.is-selected]="isSessionSelected(item)">
              <i class="{{ item.icon }} item-icon"></i>
              <div class="item-info">
                <div class="item-label" [title]="getSessionLabel(item)">
                  <span class="title" [innerHTML]="getSessionLabelHtml(item)"></span>
                  <button class="trash-button" (click)="confirmSessionDeletion(item); $event.stopPropagation()">
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
                <div class="sub-info">
                  @if (item.session) {
                    <div class="time-info">
                      <i class="pi pi-clock"></i>
                      @if (item.session.created_at) {
                        <small>{{ item.session.created_at | date: 'short' }}</small>
                      } @else {
                        <small> No date info </small>
                      }
                    </div>
                    -
                    @if (item.session.message_count) {
                      <small>
                        {{ item.session.message_count }}
                        message{{ item.session.message_count === 1 ? '' : 's' }}
                      </small>
                    } @else {
                      <small> No messages </small>
                    }
                  }
                </div>
              </div>
            </div>
          </a>
        } @else {
          <div class="sidebar-item" [class.is-selected]="isSessionSelected(item)">
            <i class="{{ item.icon }} item-icon"></i>
            <div class="item-info">
              <div class="item-label" [title]="getSessionLabel(item)">
                <span class="title" [innerHTML]="getSessionLabelHtml(item)"></span>
                <button class="trash-button" (click)="confirmSessionDeletion(item)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
              <div class="sub-info">
                @if (item.session) {
                  <div class="time-info">
                    <i class="pi pi-clock"></i>
                    @if (item.session.created_at) {
                      <small>{{ item.session.created_at | date: 'short' }}</small>
                    } @else {
                      <small> No date info </small>
                    }
                  </div>
                  -
                  @if (item.session.message_count) {
                    <small>
                      {{ item.session.message_count }} message{{ item.session.message_count === 1 ? '' : 's' }}
                    </small>
                  } @else {
                    <small> No messages </small>
                  }
                }
              </div>
            </div>
          </div>
        }
      </ng-template>
      <ng-template #loaderTemplate>
        <div class="sidebar-loader-items">
          @for (i of sidebarLoaderItems; track i) {
            <div class="sidebar-item is-loading">
              <p-skeleton shape="circle" size="2rem" styleClass="item-icon" />
              <div class="item-info">
                <p-skeleton width="215px" height="1.5rem" styleClass="item-label" />
                <div class="sub-info">
                  <div class="time-info">
                    <p-skeleton width="100px" height="1rem" />
                  </div>
                  -
                  <p-skeleton width="75px" height="1rem" />
                </div>
              </div>
            </div>
          }
        </div>
      </ng-template>
    </app-besharp-sidebar>
  </div>

  <div class="content-container" #contentContainer>
    <router-outlet></router-outlet>
  </div>
</div>
<p-toast position="bottom-center"></p-toast>
<p-confirmdialog></p-confirmdialog>
